export default __webpack_public_path__ + "static/media/capture-stones.a231b135.md";